module.exports = __webpack_public_path__ + "static/media/2018_0716_18503800-01.470c84fe.jpg";